import { View, StyleSheet, Text, Pressable } from "react-native";
import { useUISlice } from "@/models/useUISlice";
import ModalContainer from "@/ui/ModalContainer";
import { ms } from "@/ui/moderateScale";
import { useTranslation } from "react-i18next";
import { Colors } from "@/constants";
import Icon from "./Icon";
import { useUserSlice } from "@/models/useUserSlice";

const AlertWidgetTranscriptRenameSpeakers = () => {
  const visible = useUISlice((state) => state.alertTranscriptRenameSpeakers);
  const setVisible = useUISlice(
    (state) => state.setAlertTranscriptRenameSpeakers
  );
  const note = useUserSlice((state) =>
    state.notes.find((note) => note.id === visible?.noteId)
  );
  let speakersMap = new Map<string, string>();
  note?.transcript.forEach((segment) => {
    if (segment.speaker) {
      speakersMap.set(segment.speaker, segment.speaker);
    }
  });
  const speakers = Array.from(speakersMap.keys());

  const width = useUISlice((state) => state.device.width);
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <ModalContainer
      shouldPersistBackdropClick
      title={visible.title}
      onDismiss={() => setVisible(undefined)}
      hideCancel
      modalWidth={Math.min(width, 600)}
    >
      <View style={styles.spacer} />

      {speakers?.map((speaker) => (
        <View key={speaker} style={styles.buttonContainer}>
          <View style={styles.folderContainer}>
            <Text numberOfLines={1} style={styles.buttonText}>
              {speaker}
            </Text>
          </View>

          <View style={styles.actionsContainer}>
            <Pressable
              onPress={() => visible?.onSpeakerEdit(speaker)}
              style={styles.editButton}
            >
              <Icon icon="pen" style={styles.whiteIcon} />
            </Pressable>
          </View>
        </View>
      ))}
      <View style={styles.negativeMargin} />
    </ModalContainer>
  );
};

const styles = StyleSheet.create({
  spacer: {
    height: ms(16),
  },
  largerSpacer: {
    height: ms(48),
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: ms(8),
    alignItems: "center",
    flex: 1,
    borderRadius: ms(12),
    marginBottom: ms(8),
  },
  folderContainer: {
    flex: 1,
    height: ms(60),
    minHeight: ms(60),
    backgroundColor: Colors.text + "10",
    borderRadius: ms(12),
    paddingHorizontal: ms(16),
    flexDirection: "row",
    gap: ms(8),
    alignItems: "center",
  },
  actionsContainer: {
    flexDirection: "row",
    gap: ms(8),
  },
  editButton: {
    justifyContent: "center",
    alignItems: "center",
    width: ms(60),
    height: ms(60),
    borderRadius: ms(12),
    backgroundColor: Colors.text,
  },
  deleteButton: {
    justifyContent: "center",
    alignItems: "center",
    width: ms(60),
    height: ms(60),
    borderRadius: ms(12),
    backgroundColor: Colors.error,
  },
  whiteIcon: {
    tintColor: Colors.white,
  },
  buttonText: {
    fontWeight: "500",
    fontSize: ms(16),
    color: Colors.text,
  },
  negativeMargin: {
    marginBottom: -ms(16),
  },
});

export default AlertWidgetTranscriptRenameSpeakers;
